/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 22/6/2021
 * @Example
 */


import Api from '../../../services/api';
import { cancel, take, takeLatest } from "redux-saga/effects";
import { types } from "./W05F0008_actions";
import { delay } from "redux-saga";

export default function W05F0008Sagas() {
    return [
        watchGetCboEmployees(),
        watchGetPopupContract(),
        watchLoadForm(),
        watchOnCheckEdit(),
        watchOnDelete(),
        watchOnApproval(),
        watchGetCbApprove()
    ];
}
export function* getCboEmployees(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-employee', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('get cbo employee error')
    }
}

export function* watchGetCboEmployees() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0008_GET_CBO_EMPLOYEE, getCboEmployees);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getPopupContract(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0008/get-popup-choose-contract', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getPopupContract error')
    }
}

export function* watchGetPopupContract() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0008_GET_POPUP, getPopupContract);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* loadForm(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0008/get-tab-status', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('loadForm error')
    }
}

export function* watchLoadForm() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0008_LOAD_FORM, loadForm);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* onCheckEdit(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0008/check-edit', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('onCheckEdit error')
    }
}

export function* watchOnCheckEdit() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0008_CHECK_EDIT, onCheckEdit);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* onDelete(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0008/popup-delete', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('onDelete error')
    }
}

export function* watchOnDelete() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0008_DELETE, onDelete);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

//approval
export function* onApproval(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0008/menu-confirm', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('w05f0008 approval error')
    }
}

export function* watchOnApproval() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0008_APPROVAL, onApproval);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

//getCbApprove
export function* getCbApprove(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0008/get-list-cbo-approve', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('w05f0008 getCbApprove error')
    }
}

export function* watchGetCbApprove() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0008_GET_CBO_APPROVE, getCbApprove);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}
